import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.RequestModule.BankAccountCheckIndicator', {
    description: 'Please note that the bank account associated with this Bill was changed in ApprovalMax',
    expectedBankAccount: 'Contact bank account:',
    actualBankAccount: 'Updated bank account:',
});
